import styled from 'styled-components'

import Box from '@totallymoney/ui/components/Box'
import theme from '@totallymoney/ui/theme'

export const StyledCell = styled(Box)`
    justify-content: space-between;
    padding: ${theme.space10} ${theme.space20};
`

export const StyledColumnHeader = styled.div`
    display: flex;
    align-items: center;
    padding: ${theme.space20};
    background-color: ${theme.indigo20};
    border-top-left-radius: ${theme.space10};
    border-top-right-radius: ${theme.space10};
`

export const StyledColumn = styled.div`
    display: grid;

    & > ${StyledCell}:not(:last-child) {
        border-bottom: solid 1px ${theme.indigo20};
    }

    & > ${StyledCell}:last-child {
        border-bottom: solid 1px white;
    }

    ${theme.mediaMediumPlus`
        grid-template-rows: repeat(6, 1fr);

        & > ${StyledCell} {
            border-bottom: solid 1px ${theme.indigo20};
        }
    `}
`

export const StyledTable = styled(Box)`
    display: grid;

    ${theme.mediaMediumPlus`
        ${StyledColumn} + ${StyledColumn} {
            border-left: solid 1px ${theme.indigo20};
        }

        ${StyledColumn}:nth-child(3n) {
            border-left: 0;
        }

        ${StyledColumn}:first-child > ${StyledColumnHeader},
        ${StyledColumn}:nth-child(3n) > ${StyledColumnHeader} {
            border-top-right-radius: 0;
        }

        ${StyledColumn}:nth-child(2n) > ${StyledColumnHeader},
        ${StyledColumn}:last-child > ${StyledColumnHeader} {
            border-top-left-radius: 0;
        }
    `}

    ${theme.mediaLargePlus`
        ${StyledColumn} + ${StyledColumn} {
            border-left: solid 1px ${theme.indigo20};
        }

        ${StyledColumn}:not(:last-child) > ${StyledColumnHeader} {
            border-top-right-radius: 0;
        }

        ${StyledColumn}:not(:first-child) > ${StyledColumnHeader} {
            border-top-left-radius: 0;
        }
    `}
`
